import { render, staticRenderFns } from "./ChangelogPanel.vue?vue&type=template&id=447d91c2&scoped=true"
import script from "./ChangelogPanel.vue?vue&type=script&lang=js"
export * from "./ChangelogPanel.vue?vue&type=script&lang=js"
import style0 from "./ChangelogPanel.vue?vue&type=style&index=0&id=447d91c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d91c2",
  null
  
)

export default component.exports